import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Administration, AdministrationUnderline, CalendarUnderline, ConversationUnderline, Healthcare, Meeting, MouseClick, Notebook, SelfieUnderline, Statistics, StatisticsUnderline, TodoUnderline } from '@/public/img/icons';
import devices from '@/utilities/devices';
import { renderIcons } from '@/utilities/functions';

const GridContainer = styled.div`
  width: 65vw;
  margin: auto;
  padding-top: 5em;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  @media screen and (${devices.minLaptop}) and (${devices.maxLaptop}) {
    width: 75vw;
  }
  @media screen and (${devices.minTablet}) and (${devices.maxTablet}) {
    width: 95vw;
    padding-top: 3em;
  }
  @media screen and (${devices.mobile}) {
    width: 95vw;
    flex-direction: column;
    padding-top: 4em;
  }
`;

const GridElement = styled.div`
  width: 31%;
  min-height: 23vh;
  display: flex;
  justify-content: center;
  box-sizing: border-box;
  cursor: default;
  user-select: none;
  transition: .2s;
  :hover {
    transform: translateY(-4px);
  }
  @media screen and (${devices.minTablet}) and (${devices.maxTablet}) {
    width: 50%;
  }
  @media screen and (${devices.mobile}) {
    width: 100%;
    min-height: 21vh;
  }

  .icons {
    width: 2em;
    svg {
      width: 1.8em;
      path {
        stroke: ${props => props.theme.color.blackLight};
      }
      g {
        stroke: ${props => props.theme.color.blackLight};
      }
    }
  }
  .text {
    width: 65%;
    padding-left: 1.3em;
    b {
      display: block;
      font-size: 1.15em;
      :first-letter {
        text-transform: uppercase;
      }
      @media screen and (${devices.mobile}) {
        font-size: 1em;
      }
    }
    p {
      margin: 0;
      :first-letter {
        text-transform: uppercase;
      }
      @media screen and (${devices.minLaptop}) and (${devices.maxLaptop}) {
        font-size: .9em;
      }
    }
    @media screen and (${devices.minLaptop}) and (${devices.maxLaptop}) {
      width: 75%;
    }
  }
`;

const GridList = ({ content }) => {
	return (
		<GridContainer>
			{content.map((el, key) => (
				<GridElement key={key}>
					<div className="icons">
						{renderIcons(el.icon, {
							Administration,
							AdministrationUnderline,
							CalendarUnderline,
							Healthcare,
							Meeting,
							MouseClick,
							Notebook,
							SelfieUnderline,
							Statistics,
							StatisticsUnderline,
							ConversationUnderline,
							TodoUnderline,
						})}
					</div>
					<div className="text">
						<b>{el.title}</b>
						<p>{el.text}</p>
					</div>
				</GridElement>
			))}
		</GridContainer>
	);
};

GridList.propTypes = {
	content: PropTypes.array,
};

export default GridList;
